import { useEffect, useRef } from "react";
import { showNotification } from "../../../../../redux/notifications/notificationsSlice";
import { useDispatch } from "react-redux";

export default function useAutoSaveBuildings(
  buildings,
  debouncedBuildings,
  updateBuildingData,
  isEditMode // new parameter
) {
  const dispatch = useDispatch();
  const lastSavedRef = useRef({});
  const isInitialized = useRef(false);

  // Initialize the stored copy only when in edit mode.
  useEffect(() => {
    if (!isEditMode) return;
    if (buildings && buildings.length > 0 && !isInitialized.current) {
      buildings.forEach((building) => {
        if (building && building.buildingID) {
          lastSavedRef.current[building.buildingID] = { ...building };
        }
      });
      isInitialized.current = true;
    }
  }, [buildings, isEditMode]);

  // Only auto-save when in edit mode.
  useEffect(() => {
    if (!isEditMode) return;
    if (!isInitialized.current) return;
    debouncedBuildings.forEach((building) => {
      if (!building || !building.buildingID) return;
      const key = building.buildingID;
      // Compare only the customerID property
      if (
        !lastSavedRef.current[key] ||
        building.customerID !== lastSavedRef.current[key].customerID
      ) {
        (async () => {
          try {
            await updateBuildingData(building.buildingID, building);
            lastSavedRef.current[key] = { ...building };
            dispatch(
              showNotification({
                message: "Building auto-saved.",
                type: "success",
              })
            );
          } catch (error) {
            dispatch(
              showNotification({
                message: `Auto-save failed: ${error.message}`,
                type: "error",
              })
            );
          }
        })();
      }
    });
  }, [debouncedBuildings, dispatch, updateBuildingData, isEditMode]);
}
